import { getMemberRoles } from '../members/members-selectors';
import { intersection } from 'lodash';
import { mapMemberRoleToMaRole } from '../../utils/map-member-role-to-ma-role';
export const getMaNavigation = (state) => state.maNavigation;
export const getIsMemberNavigatable = (state, memberId) => {
    const { navigatableMembersRoles, isNavigationAllowed } = getMaNavigation(state);
    if (isNavigationAllowed && typeof memberId !== 'undefined') {
        if (navigatableMembersRoles.length === 0) {
            return true;
        }
        else {
            const memberRoles = getMemberRoles(state, memberId)
                .map((role) => mapMemberRoleToMaRole(role))
                .filter((d) => d);
            return intersection(navigatableMembersRoles, memberRoles).length > 0;
        }
    }
    return false;
};
export const getProfileLinkTemplate = (state) => state.maNavigation.profileLinkTemplate;
//# sourceMappingURL=ma-navigation-selectors.js.map